import { useState, useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';

export interface GenerateAuthCodeRequest {
  accountType: 'analytics' | 'audytor';
}

export const useAuthCode = () => {
  const [isGenerating, setIsGenerating] = useState(false);
  const { toast } = useToast();

  // Generowanie kodu autoryzacyjnego przez n8n
  const generateAuthCode = useCallback(async (request: GenerateAuthCodeRequest) => {
    setIsGenerating(true);
    
    try {
      console.log('[useAuthCode] 🚀 Sending request to n8n for:', request.accountType);
      
      // Wywołanie Supabase Edge Function jako proxy do n8n
      const { data, error } = await supabase.functions.invoke('generate-auth-code', {
        body: {
          Wybierz_konto: request.accountType
        }
      });

      if (error) {
        console.error('[useAuthCode] ❌ Error sending to n8n:', error);
        throw new Error(error.message || 'Błąd wysyłania żądania do n8n');
      }

      console.log('[useAuthCode] ✅ Response from n8n:', data);
      
      toast({
        title: "Kod wygenerowany!",
        description: `Kod dla ${request.accountType === 'analytics' ? 'Analytics' : 'Audytor'} został wygenerowany przez n8n i wysłany do Ciebie.`,
      });

      return data;
      
    } catch (error) {
      console.error('[useAuthCode] ❌ Error in generateAuthCode:', error);
      
      const errorMessage = error instanceof Error ? error.message : 'Wystąpił błąd podczas generowania kodu';
      
      toast({
        title: "Błąd generowania kodu",
        description: errorMessage,
        variant: "destructive",
      });
      
      throw error;
    } finally {
      setIsGenerating(false);
    }
  }, [toast]);

  return {
    // Stan
    isGenerating,
    
    // Akcje
    generateAuthCode,
  };
};
